export const DAT_HANG_NCC_PERMISSION_CODES = {
  WEB_BH_DAT_HANG_NCC_LIST: 'WEB_BH_DAT_HANG_NCC_LIST',
  WEB_BH_DAT_HANG_NCC_DETAIL: 'WEB_BH_DAT_HANG_NCC_DETAIL',
  WEB_BH_DAT_HANG_NCC_ADD: 'WEB_BH_DAT_HANG_NCC_ADD',
  WEB_BH_DAT_HANG_NCC_EDIT: 'WEB_BH_DAT_HANG_NCC_EDIT',
  WEB_BH_DAT_HANG_NCC_DELETE: 'WEB_BH_DAT_HANG_NCC_DELETE',
  WEB_BH_DAT_HANG_NCC_STATUS: 'WEB_BH_DAT_HANG_NCC_STATUS',
  WEB_BH_DAT_HANG_NCC_EXPORT: 'WEB_BH_DAT_HANG_NCC_EXPORT',
  WEB_BH_DAT_HANG_NCC_IMPORT: 'WEB_BH_DAT_HANG_NCC_IMPORT',
  WEB_BH_DAT_HANG_NCC_COPY: 'WEB_BH_DAT_HANG_NCC_COPY',
  WEB_BH_DAT_HANG_NCC_CANCEL: 'WEB_BH_DAT_HANG_NCC_CANCEL',
  WEB_BH_DAT_HANG_NCC_COMPLETE: 'WEB_BH_DAT_HANG_NCC_COMPLETE',
} as const

export const DAT_HANG_NCC_MUTATE_PERMISSIONS = [
  DAT_HANG_NCC_PERMISSION_CODES.WEB_BH_DAT_HANG_NCC_ADD,
  DAT_HANG_NCC_PERMISSION_CODES.WEB_BH_DAT_HANG_NCC_EDIT,
  DAT_HANG_NCC_PERMISSION_CODES.WEB_BH_DAT_HANG_NCC_DELETE,
  DAT_HANG_NCC_PERMISSION_CODES.WEB_BH_DAT_HANG_NCC_STATUS,
  DAT_HANG_NCC_PERMISSION_CODES.WEB_BH_DAT_HANG_NCC_EXPORT,
  DAT_HANG_NCC_PERMISSION_CODES.WEB_BH_DAT_HANG_NCC_IMPORT,
  DAT_HANG_NCC_PERMISSION_CODES.WEB_BH_DAT_HANG_NCC_COPY,
  DAT_HANG_NCC_PERMISSION_CODES.WEB_BH_DAT_HANG_NCC_CANCEL,
  DAT_HANG_NCC_PERMISSION_CODES.WEB_BH_DAT_HANG_NCC_COMPLETE,
] as const
